import React, { useEffect, useSyncExternalStore } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { ToastContainer, useToast } from './toast';
import { useAuth } from '../../contexts/AuthContext';
import { FEEDBACK_EVENT, soundsEnabled, subscribeSounds, setSoundsEnabled, unlockFeedbackAudio, releaseFeedbackAudio, playFeedbackSound, resetFeedbackSession } from '../../lib/interactionFeedback';

export function SoundMenuItem() {
  const enabled = useSyncExternalStore(subscribeSounds, soundsEnabled, () => false);
  return <button type="button" role="menuitemcheckbox" aria-checked={enabled} className="menu-item" onClick={() => {
    setSoundsEnabled(!enabled);
    if (!enabled) playFeedbackSound('saved');
  }}>{enabled ? <Volume2 size={15}/> : <VolumeX size={15}/>}Reaction sounds <span className="sound-setting-value">{enabled ? 'On' : 'Off'}</span></button>;
}

export default function ActionFeedback() {
  const { user } = useAuth();
  const { toasts, addToast, removeToast, clearToasts } = useToast();
  useEffect(() => { resetFeedbackSession(); clearToasts(); return resetFeedbackSession; }, [user?.id, clearToasts]);
  useEffect(() => {
    const pointer = () => { document.documentElement.dataset.inputModality = 'pointer'; unlockFeedbackAudio(); };
    const keyboard = event => { if (!['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) document.documentElement.dataset.inputModality = 'keyboard'; };
    const receive = event => {
      const { kind, message, detail, motion } = event.detail;
      addToast(message, kind === 'error' ? 'error' : 'success', 4000, { reaction: kind, detail, motion });
    };
    document.addEventListener('pointerdown', pointer, true); document.addEventListener('keydown', keyboard, true);
    window.addEventListener(FEEDBACK_EVENT, receive);
    return () => {
      document.removeEventListener('pointerdown', pointer, true); document.removeEventListener('keydown', keyboard, true);
      window.removeEventListener(FEEDBACK_EVENT, receive); releaseFeedbackAudio();
    };
  }, [addToast]);
  return <ToastContainer toasts={toasts} removeToast={removeToast}/>;
}
